import {ProfileProvider} from "../context/ProfileContext";
import ProfileEditContent from "../components/ProfileEdit/ProfileEditContent";
import PageTitle from "../components/Title/Responsive/PageTitle/PageTitle";

const ProfileEdit = () => {
    return (
        <ProfileProvider>
            <PageTitle title={'Edit Profile'} />
            <ProfileEditContent />
        </ProfileProvider>
    )
}

export default ProfileEdit;
